import React from 'react'
import BrandedError from '../../components/BrandedError'

const NotFound = () => {
  return (
    <BrandedError
      status="404"
      title="404"
      subTitle="The dashboard page your'e looking for is currently unavailable."
      redirect="/app"
    />
  )
}

export default NotFound
